// css =>
import "../../BaseStructure.css";
import Styled from "./desktopSubMenu.module.css";

function DestopSubMenu (props: {
    subMenuOptions: string[];
    sunMenuWidthByPixel?: number;
    onItemClick?: (item: string, index: number) => void;
    selectedOptionIndex?: number;
}) {
    return (
        <div className={Styled.dropdown}>
            <div className={` row ${ Styled.menu } `}>
                {
                    props.subMenuOptions.map((item, index) => {
                        return (
                            <div
                                className="row"
                                key={ index }
                                onClick={() => props.onItemClick ? props.onItemClick(item, index) : {}}
                            >
                                <div className={`col-1 ${ Styled.CheckBox } `}>
                                    <div className={`col-1 ${ props.selectedOptionIndex === index ? Styled.activeOption : "" } `}></div>
                                </div>

                                <div className={` col-8 ${ Styled.item } `}>
                                    <p>
                                        {
                                            item
                                        }
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default DestopSubMenu;
